import { PurchaseableSubTier, PurchaseableTier } from '@sparemin/api-sdk';
import React from 'react';
import { useDispatch } from 'react-redux';
import { EXPERIMENTS_NAMES } from 'blocks/ABTest';
import SocialProofSection from 'blocks/Pricing/components/SocialProofSection';
import useExperiment from 'hooks/useExperiment';
import { pushModal } from 'redux/modules/modal/actions';
import { SubscriptionPeriod } from '../../types';
import PlanSelector from '../PlanSelector';
import EnterpriseBanner from './EnterpriseBanner';
import FreeSubscriptionFooter from './FreeSubscriptionFooter';

const { useCallback } = React;

export interface BaseFreeSubscriptionProps {
  className?: string;
  freePlanCta?: React.ReactElement;
  message?: string;
  subMessage?: React.ReactNode;
}

const BaseFreeSubscription: React.FC<BaseFreeSubscriptionProps> = ({
  className,
  freePlanCta,
  message,
  subMessage,
}) => {
  const { activeVariant } = useExperiment(EXPERIMENTS_NAMES.proGrowSelector);
  const isVariantB = activeVariant === 'B';

  const dispatch = useDispatch();

  const handleUpgradeClick = useCallback(
    (
      tier: PurchaseableTier,
      subPeriod: SubscriptionPeriod,
      subtier?: PurchaseableSubTier,
    ) => {
      dispatch(
        pushModal({
          name: 'AddBillingCycle',
          params: {
            tier,
            subtier,
            defaultSubscriptionPeriod: subPeriod,
          },
        }),
      );
    },
    [dispatch],
  );

  return (
    <PlanSelector {...{ className, message, subMessage }}>
      <PlanSelector.PlanList>
        <PlanSelector.FreePlan cta={freePlanCta} />
        <PlanSelector.BasicPlan
          location="MyPlanPage"
          onUpgradeClick={handleUpgradeClick}
        />
        <PlanSelector.ProPlan
          location="MyPlanPage"
          onUpgradeClick={handleUpgradeClick}
        />

        {isVariantB && (
          <PlanSelector.ProGrowPlan
            location="MyPlanPage"
            onUpgradeClick={handleUpgradeClick}
          />
        )}
      </PlanSelector.PlanList>
      <SocialProofSection />
      <EnterpriseBanner />
      <FreeSubscriptionFooter />
    </PlanSelector>
  );
};

export default BaseFreeSubscription;
